import { getAddresses } from 'redux/modules/address/actions';
import { isUserLoggedIn } from 'redux/modules/sessions/selectors';
import { getAllAddressesRequestStatus } from 'redux/modules/address/selectors';

// Separated out from index.js to reduce unnecessary dependency loading
export const addressesFetcher = () => (dispatch, getState) => {
  const state = getState();
  if (isUserLoggedIn(state)) {
    const allAddressesRequestStatus = getAllAddressesRequestStatus(state);
    if (allAddressesRequestStatus !== 'loaded' && allAddressesRequestStatus !== 'loading') {
      return dispatch(getAddresses());
    }
  }

  return Promise.resolve();
};
